import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import HubSpotLandingHelmet from 'common/helmets/HubSpotLandingHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';
import HubSpotLogo from 'img/landing/canny-hubspot-integration.webp';
import HubSpot1 from 'img/landing/hubspot-1.webp';
import HubSpot2 from 'img/landing/hubspot-2.webp';
import HubSpot3 from 'img/landing/hubspot-3.webp';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class HubSpotLanding extends Component {
  static propTypes = {
    showIntercom: PropTypes.func,
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed HubSpot Integration Page');
  }

  onContactUsTapped = () => {
    this.props.showIntercom();
  };

  renderCTA() {
    const { viewer } = this.props;
    if (!viewer || viewer.loggedOut || viewer.companies.length === 0) {
      // logged out || no companies -> register
      return (
        <Link className="cta" to="/register">
          <Button buttonType="greenButton" value="Get started" />
        </Link>
      );
    }

    // logged in && has company -> admin dashboard (assume first company for now)
    return (
      <Button
        buttonType="blackButton"
        className="cta"
        onTap={this.onContactUsTapped}
        value="Contact Us for access"
      />
    );
  }

  render() {
    return (
      <div className="integrationsLanding">
        <HubSpotLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage
                alt="HubSpot logo"
                className="appLogo"
                loading="eager"
                src={HubSpotLogo}
              />
              <div className="text">
                <h1 className="title">Canny for HubSpot</h1>
                <div className="subtitle">
                  Track feedback on behalf of contacts and deals in&nbsp;HubSpot
                </div>
                <div className="links">
                  {this.renderCTA()}
                  <a
                    href="https://help.canny.io/en/articles/5876904-hubspot-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={HubSpot1} />
              </div>
              <div className="featureText">
                <div className="title">Keep track of your prospect's dealbreakers</div>
                <div className="subtitle">
                  Close more deals by staying on top of what prospects are asking for. You'll know
                  the status of these requests from your product&nbsp;team.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={HubSpot2} />
              </div>
              <div className="featureText">
                <div className="title">No need to leave&nbsp;HubSpot</div>
                <div className="subtitle">
                  Send feedback to your product team without disrupting your current workflow.
                  Search and create Canny posts from&nbsp;HubSpot.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={HubSpot3} />
              </div>
              <div className="featureText">
                <div className="title">All your feedback in one&nbsp;place</div>
                <div className="subtitle">
                  Canny keeps track of all votes that came from HubSpot. Link potential revenue
                  opportunities to inform your product&nbsp;decisions.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    showIntercom: ShowIntercomContext,
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  }),
  hot,
)(HubSpotLanding);
